<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Stock Transfer Deliveries</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="FromStore" :items="stores" label="From Shop"
              item-text="Name" item-value="id"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="ToStore" :items="stores" label="To Store"
              item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="3">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="StartDate" label="From"
                  prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" sm="12" md="3">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="EndDate" label="To" prepend-icon="mdi-calendar-month"
                  v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker v-model="EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3">
            <v-btn color="primary" @click="getRecords">Query Data</v-btn>
          </v-col>

        </v-row>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-text-field v-model="search" label="Search" outlined dense></v-text-field>
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="transferHeaders" :items="stockTransfers"
              :search="search">
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/stock-transfer/${item.id}`" icon>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.date="{ item }">
                {{ item.date | date }}
              </template>

              <template v-slot:item.received="{ item }">
                <span style="color: green; font-weight: bold" v-if="item.received == 'Y'">Received</span>
                <span style="color: red; font-weight: bold" v-if="item.received == 'N'">Not Received Yet</span>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- pdf preview -->
        <pdf-preview ref="pdfPreview"></pdf-preview>
        <!-- snackbar -->
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { generatePdf } from "@/common/transferMethods.js";
import { http } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      pageItems: 100,
      menu1: false,
      menu2: false,
      StartDate: new Date().toISOString().substr(0, 10),
      EndDate: new Date().toISOString().substr(0, 10),
      FromStore: null,
      ToStore: null,
      PickedBy: null,
      loader: false,
      stores: [],
      users: [],
      transferHeaders: [
        { text: "Doc No", value: "DocNum" },
        { text: "From", value: "fromStore.Name" },
        { text: "To", value: "toStore.Name" },
        { text: "PickedBy", value: "pickedBy.name" },
        { text: "Total", value: "DocTotal" },
        { text: "Date", value: "date" },
        { text: "Action", value: "action" },
      ],
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Ref No./ IMEI", value: "ref1" },
        { text: "Quantity", value: "Quantity" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Total", value: "LineTotal" },
        { text: "From Shop", value: "fromstore.Name" },
        { text: "To Store", value: "tostore.Name" },
        { text: "Picked By", value: "pickedBy.name" },
        { text: "Status", value: "received" },
        { text: "Date", value: "DocDate" },
      ],
      stockTransfers: [],
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    totalAmount() {
      let total = 0;
      if (
        typeof this.stockTransfers != "undefined" &&
        this.stockTransfers.length > 0
      ) {
        return this.stockTransfers
          .map((item) => {
            const amount = item.Quantity * item.BuyingPrice;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  methods: {
    generatePdf,
    getRecords() {
      const self = this;
      const data = {
        StartDate: self.StartDate,
        EndDate: self.EndDate,
        FromStore: self.FromStore,
        ToStore: self.ToStore,
        ProductId: 0
      };

      self.loader = true;
      const url = `/stock-transfer-deliveries`;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.stockTransfers = res.ResponseData;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    thermalPrint() {
      const self = this;
      const storeId = this.ToStore;

      const store = this.stores.find((record) => {
        return record.id === storeId;
      });

      let storeName = "";

      if (store) {
        storeName = store.Name;
      }
      let details = {
        storeName: storeName,
        stock: self.stockTransfers,
        date: self.StartDate,
      };

      self.printLocalInventory(details);
    },
    printLocalInventory(stock) {
      return http.post(
        "http://localhost/stalispos-receipt/src/inventory/StockTransfer.php",
        {
          stock,
        }
      );
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    updateDeliveries() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/update-transfer-deliveries`)
        .then((res) => {
          if (res.ResultCode == 1200) {
          self.$refs.snackbar.show("Update successful", "green");
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }

          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          self.loader = false;
        });
    },
    printDoc() {
      if (this.StartDate == null || this.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        const self = this;
        const pdfDoc = this.generatePdf(
          self.StartDate,
          self.EndDate,
          self.stockTransfers
        );

        this.$refs.pdfPreview.show(pdfDoc);
      }
    },
  },
  created() {
    Promise.all([this.getStores(), this.getUsers(), this.getRecords()]);
  },
};
</script>

<style lang="scss" scoped></style>